import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../../../config/queryClient'
import { fetchInvoices } from '../../../query-api'
import { InvoicesQueryProps } from '../../../types/invoicesQueryProps'
import { getInvoicesQueryKey } from '../../../utils/getInvoicesQueryKey'

export interface UseIsInvoicesListEmptyResult {
  isInvoicesListEmpty: boolean
  isLoading: boolean
}

export const useIsInvoicesListEmpty = (): UseIsInvoicesListEmptyResult => {
  const { organization } = useUserOrganization()

  const queryProps: InvoicesQueryProps = useMemo(
    () => ({
      page: 1,
      pageSize: 1 as ItemsPerPage,
      status: InvoiceStatus.All,
      organizationId: organization?.id as string,
    }),
    [organization],
  )

  const queryKey = useMemo(() => getInvoicesQueryKey(queryProps), [queryProps])

  const { data: invoicesCountData, isFetched: invoicesCountFetched } = useQuery(
    queryKey,
    () => fetchInvoices(queryProps),
    {
      enabled: !!organization,
      staleTime: defaultStaleTime,
    },
  )

  return {
    isInvoicesListEmpty: invoicesCountFetched && invoicesCountData?.invoices.length === 0,
    isLoading: !invoicesCountFetched,
  }
}
